<template>
  <q-toolbar v-bind="$attrs">
    <slot></slot>
  </q-toolbar>
</template>
